module.exports = __webpack_public_path__ + "static/reg-large12-4d516d7aeedd261e0229abb141df8edc.jpg";